import * as actionTypes from "./ActionTypes";

export const toggleDialogsAction = (dialog, state) => {
  return { type: actionTypes.TOGGLE_DIALOGS, dialog, state };
};

export const clearhubStateAction = (state) => {
  return { type: actionTypes.CLEAR_MICROHUB_STATE, state };
};

export const getHubsAction = (data) => {
  return { type: actionTypes.GET_ALL_HUBS, data };
};
export const getHubsSuccessAction = (res, forMap) => {
  return { type: actionTypes.GET_ALL_HUBS_SUCCESS, res, forMap };
};
export const getHubsFailAction = (error) => {
  return { type: actionTypes.GET_ALL_HUBS_FAIL, error };
};

export const createHubAction = (data) => {
  return { type: actionTypes.CREATE_HUB, data };
};
export const createHubSuccessAction = (res) => {
  return { type: actionTypes.CREATE_HUB_SUCCESS, res };
};
export const createHubFailAction = (error) => {
  return { type: actionTypes.CREATE_HUB_FAIL, error };
};

export const editHubAction = (data) => {
  return { type: actionTypes.EDIT_HUB, data };
};
export const editHubSuccessAction = (res) => {
  return { type: actionTypes.EDIT_HUB_SUCCESS, res };
};
export const editHubFailAction = (error) => {
  return { type: actionTypes.EDIT_HUB_FAIL, error };
};

export const deleteHubAction = (data) => {
  return { type: actionTypes.DELETE_HUB, data };
};
export const deleteHubSuccessAction = (res) => {
  return { type: actionTypes.DELETE_HUB_SUCCESS, res };
};
export const deleteHubFailAction = (error) => {
  return { type: actionTypes.DELETE_HUB_FAIL, error };
};

export const getHubByIdAction = (data) => {
  return { type: actionTypes.GET_HUB_BY_ID, data };
};
export const getHubByIdSuccessAction = (res) => {
  return { type: actionTypes.GET_HUB_BY_ID_SUCCESS, res };
};
export const getHubByIdFailAction = (error) => {
  return { type: actionTypes.GET_HUB_BY_ID_FAIL, error };
};

export const assignPolygonToHubAction = (data) => {
  return { type: actionTypes.ASSIGN_POLYGON_TO_HUB, data };
};
export const assignPolygonToHubSuccessAction = (res) => {
  return { type: actionTypes.ASSIGN_POLYGON_TO_HUB_SUCCESS, res };
};
export const assignPolygonToHubFailAction = (error) => {
  return { type: actionTypes.ASSIGN_POLYGON_TO_HUB_FAIL, error };
};

export const removeHubFromPolygonAction = (data) => {
  return { type: actionTypes.REMOVE_HUB_FROM_POLYGON, data };
};
export const removeHubFromPolygonSuccessAction = (res) => {
  return { type: actionTypes.REMOVE_HUB_FROM_POLYGON_SUCCESS, res };
};
export const removeHubFromPolygonFailAction = (error) => {
  return { type: actionTypes.REMOVE_HUB_FROM_POLYGON_FAIL, error };
};
